import { TextArea, TextInput } from 'framework/form';
import { fieldTypeOf } from '../../field-types';
import type { Element } from '../../format/form-definition';
import { useBuilder } from '../context';
import { ElementTextKey } from '../edits/elementEdits';
import { CardSettings } from './CardSettings';

interface DescriptionInputProps {
  description: string | undefined;
  onDescription: (description: string) => void;
}

const DescriptionInput = ({ description, onDescription }: DescriptionInputProps) => {
  return (
    <TextArea
      rows={3}
      label="Helper text"
      source={'description'}
      value={description ?? ''}
      onChangeCallback={({ description: text }) => onDescription(text)}
    />
  );
};

export const KindContent = ({ element }: { element: Element }) => {
  const { edit } = useBuilder();
  const setText = (key: ElementTextKey) => (text: string) =>
    edit({ kind: 'setElementText', elementId: element.id, key, text });

  switch (element.kind) {
    case 'field':
      return (
        <>
          <TextInput
            source="label"
            label="Label"
            value={element.label}
            onChangeCallback={({ label }) => setText('label')(label)}
          />
          <DescriptionInput description={element.description} onDescription={setText('description')} />
          {fieldTypeOf(element).settingsPanel?.at === 'general' && <CardSettings field={element} />}
        </>
      );
    case 'section':
      return (
        <>
          <TextInput
            source="title"
            label="Title"
            value={element.title}
            onChangeCallback={({ title }) => setText('title')(title)}
          />
          <DescriptionInput description={element.description} onDescription={setText('description')} />
        </>
      );
    case 'staticText':
      return (
        <TextArea
          rows={3}
          source={'text'}
          label="Text"
          value={element.text}
          onChangeCallback={({ text }) => setText('text')(text)}
        />
      );
  }
};
